import React, { useState } from "react";
import { ChevronsUpDown, Check } from "lucide-react";
import { Button } from "./ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover";
import {
  Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList,
} from "./ui/command";
import { cn } from "../lib/utils";

// Controlled multi-select. `value` is an array of strings; onChange gets the new array.
export function MultiSelect({ value = [], onChange, options = [], placeholder = "All", searchPlaceholder = "Search…", testid }) {
  const [open, setOpen] = useState(false);
  const toggle = (v) => {
    onChange(value.includes(v) ? value.filter((x) => x !== v) : [...value, v]);
  };
  const label = value.length === 0 ? placeholder : value.length === 1 ? value[0] : `${value.length} selected`;

  return (
    <Popover open={open} onOpenChange={setOpen} modal={true}>
      <PopoverTrigger asChild>
        <Button type="button" variant="outline" role="combobox" data-testid={testid}
          className="w-full justify-between rounded-sm font-normal">
          <span className={cn("truncate", value.length === 0 && "text-muted-foreground")}>{label}</span>
          <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[--radix-popover-trigger-width] p-0 bg-card" align="start">
        <Command>
          <CommandInput placeholder={searchPlaceholder} data-testid={testid ? `${testid}-search` : undefined} />
          <CommandList>
            <CommandEmpty>No match.</CommandEmpty>
            <CommandGroup>
              {options.map((opt) => {
                const selected = value.includes(opt);
                return (
                  <CommandItem key={opt} value={opt} onSelect={() => toggle(opt)}
                    data-testid={testid ? `${testid}-option-${opt}` : undefined}>
                    <div className={cn("mr-2 flex h-4 w-4 items-center justify-center rounded-sm border",
                      selected ? "bg-primary border-primary text-primary-foreground" : "border-input")}>
                      {selected && <Check className="h-3 w-3" />}
                    </div>
                    <span className="truncate">{opt}</span>
                  </CommandItem>
                );
              })}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
